import { memo } from 'react'
import TextWrapper from '../TextWrapper'
import { URL_REGX } from 'app/utils/regex'
import styles from './styles.module.scss'

function Text({ title, textContent, renderRepliedMsgPreview, className, renderEditedMsgSubtitle, type }) {
  let splittedByUrl = textContent.split(URL_REGX)
  let links = []

  const renderLink = (href, text, key) => (
    <a key={key} target="_blank" rel="noreferrer" href={href}>
      {text}
    </a>
  )

  const adaptedText = splittedByUrl.map((item, index) => {
    // identifies links to build special message for them
    if (item.match(URL_REGX)) {
      links.push(item)
      return renderLink(item, item, index)
    }

    return item
  })

  const renderLinksSection = links.length > 0 && (
    <div data-type={type} className={styles.message_link_container}>
      {links.map((item, index) => renderLink(item, item.split('//')[1], index))}
    </div>
  )

  return (
    <TextWrapper type={type} title={title} className={className}>
      {renderRepliedMsgPreview}
      <>
        {adaptedText}
        {renderLinksSection}
      </>
      {renderEditedMsgSubtitle}
    </TextWrapper>
  )
}

export default memo(Text)
